<template>
    <div>
        <div class="grid-x grid-padding-x">
            <div class="cell small-12 pad-top">
                <h1>All garments</h1>
            </div>
        </div>
        <div
            v-bind:class="{ hide: !started }"
            class="pad-top">
            <div class="grid-x grid-padding-x pad-bottom">
                <div class="cell small-12 medium-6 medium-order-2">
                    <div
                        v-if="activeMode === 'Design'"
                        class="show-for-medium bordered light shadowed marg-bottom">
                        <ul class="design-nav">
                            <li
                                v-on:click="selectSide('Front')"
                                v-bind:class="{ active : selectedSide === 'Front' }">
                                Front
                            </li>
                            <li
                                v-on:click="selectSide('Back')"
                                v-bind:class="{ active : selectedSide === 'Back' }">
                                Back
                            </li>
                            <li
                                v-on:click="selectSide('Left')"
                                v-bind:class="{ active : selectedSide === 'Left' }">
                                Left
                            </li>
                            <li
                                v-on:click="selectSide('Right')"
                                v-bind:class="{ active : selectedSide === 'Right' }">
                                Right
                            </li>
                        </ul>
                    </div>
                    <div class="pad-bottom--small">
                        <div class="bordered light shadowed">
                            <ul class="function-nav">
                                <li
                                    v-on:click="selectMode('Products')"
                                    class="icon icon-products"
                                    v-bind:class="{ active : activeMode === 'Products' }">
                                    Products
                                </li>
                                <li
                                    v-on:click="selectMode('Design')"
                                    class="icon icon-design"
                                    v-bind:class="{ active : activeMode === 'Design' }">
                                    Design
                                </li>
                            </ul>
                            <div
                                v-if="selectedFunction === 'Products'"
                                class="pad">
                                <h4>Garments</h4>
                                <p>
                                    Choose new garments on the left.
                                </p>
                            </div>

                            <div
                                class="marg-top"
                                v-if="activeMode === 'Design'">
                                <span
                                    v-on:click="selectFunction('Upload')"
                                    class="function-switch green text-green"
                                    v-if="activeMode === 'Design'"
                                    v-bind:class="{ active : selectedFunction === 'Upload' }">
                                    <i
                                        class="material-icons xl text-green"
                                        style="position:relative; top: 12px; left: -20px;">
                                        unarchive
                                    </i>
                                    Upload Your Logo
                                </span>
                                <div
                                    v-if="selectedFunction === 'Upload'"
                                    class="pad">
                                    <app-uploader v-on:uploadFinished="uploadHasFinished"></app-uploader>
                                </div>


                                <!--
                                <div style="display: inline-block; margin-left: 10px">
                                    <button id="drawing-mode" class="button small">Cancel drawing mode</button><br>
                                    <button id="clear-canvas" class="button small">Clear</button><br>

                                    <div id="drawing-mode-options">
                                        <label for="drawing-mode-selector">Mode:</label>
                                        <select id="drawing-mode-selector">
                                        <option>Pencil</option>
                                        <option>Circle</option>
                                        <option>Spray</option>
                                        <option>Pattern</option>

                                        <option>hline</option>
                                        <option>vline</option>
                                        <option>square</option>
                                        <option>diamond</option>
                                        <option>texture</option>
                                        </select><br>

                                        <label for="drawing-line-width">Line width:</label>
                                        <span class="info">9</span><input type="range" value="30" min="0" max="150" id="drawing-line-width"><br>

                                        <label for="drawing-color">Line color:</label>
                                        <input type="color" value="#005E7A" id="drawing-color"><br>

                                        <label for="drawing-shadow-color">Shadow color:</label>
                                        <input type="color" value="#005E7A" id="drawing-shadow-color"><br>

                                        <label for="drawing-shadow-width">Shadow width:</label>
                                        <span class="info">28</span><input type="range" value="0" min="0" max="50" id="drawing-shadow-width"><br>

                                        <label for="drawing-shadow-offset">Shadow offset:</label>
                                        <span class="info">0</span><input type="range" value="0" min="0" max="50" id="drawing-shadow-offset"><br>
                                    </div>
                                </div>
                                -->

                                <span
                                    v-on:click="selectFunction('Text')"
                                    class="icon icon-upload function-switch"
                                    v-if="activeMode === 'Design'"
                                    v-bind:class="{ active : selectedFunction === 'Text' }">
                                    <i
                                        class="material-icons xl"
                                        style="position:relative; top: 12px; left: -20px;">
                                        text_format
                                    </i>
                                    Add Your Text
                                </span>
                                <div
                                    v-if="selectedFunction === 'Text'"
                                    class="pad">
                                    <div class="grid-x grid-padding-x">
                                        <div class="cell small-12 medium-6">
                                            <button
                                                v-on:click="addText('embroideredText')"
                                                class="button tall light-blue squared expanded">Add Embroidered Text
                                            </button>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <button
                                                v-on:click="addText('printedText')"
                                                class="button tall light-blue squared expanded">Add Printed Text
                                            </button>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <select
                                                v-model="textColor"
                                                v-on:change="updateTextColour">
                                                <option style="color:#000; font-weight:bold;" value="#000">Black</option>
                                                <option style="color:#FFF; font-weight:bold;" value="#FFF">White</option>
                                                <option style="color:#FF0000; font-weight:bold;" value="#FF0000">Red</option>
                                                <option style="color:#00FF00; font-weight:bold;" value="#00FF00">Green</option>
                                                <option style="color:#0000FF; font-weight:bold;" value="#0000FF">Blue</option>
                                                <option style="color:#582707; font-weight:bold;" value="#582707">Seal Brown</option>
                                                <option style="color:#972D07; font-weight:bold;" value="#972D07">Smokey Topaz</option>
                                                <option style="color:#FF4B3E; font-weight:bold;" value="#FF4B3E">Ogre Odour</option>
                                                <option style="color:#FFB20F; font-weight:bold;" value="#FFB20F">Dark Tangerine</option>
                                                <option style="color:#FFE548; font-weight:bold;" value="#FFE548">Lemon</option>
                                                <option style="color:#FF312E; font-weight:bold;" value="#FF312E">Deep Pink</option>
                                                <option style="color:#333138; font-weight:bold;" value="#333138">Jet</option>
                                                <option style="color:#B8DBD9; font-weight:bold;" value="#B8DBD9">Columbia Blue</option>
                                                <option style="color:#17BEBB; font-weight:bold;" value="#17BEBB">Jewel Blue</option>
                                                <option style="color:#618B25; font-weight:bold;" value="#618B25">Olive</option>
                                                <option style="color:#B2FFA9; font-weight:bold;" value="#B2FFA9">Moss</option>
                                                <option style="color:#EEE82C; font-weight:bold;" value="#EEE82C">Dandelion</option>
                                                <option style="color:#53A548; font-weight:bold;" value="#53A548">May Green </option>
                                                <option style="color:#75485E; font-weight:bold;" value="#75485E">Purple</option>
                                                <option style="color:#38AECC; font-weight:bold;" value="#38AECC">Blue</option>
                                                <option style="color:#0090C1; font-weight:bold;" value="#0090C1">Alt Blue</option>
                                                <option style="color:#046E8F; font-weight:bold;" value="#046E8F">Sea Blue</option>
                                            </select>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <select
                                                v-model="textFont"
                                                v-on:change="updateTextFont">
                                                <option style="font-family:arial" value="Arial">Arial</option>
                                                <option style="font-family:arial black" value="Arial Black">Arial Black</option>
                                                <option style="font-family:bookman" value="Impact">Bookman</option>
                                                <option style="font-family:tahoma" value="Tahoma">Tahoma</option>
                                                <option style="font-family:times new roman" value="Times New Roman">Times New Roman</option>
                                            </select>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <select
                                                v-model="textAlign"
                                                v-on:change="updateTextAlign">
                                                <option value="left">Left</option>
                                                <option value="right">Right</option>
                                                <option value="center">Center</option>
                                                <option value="justify">Justify</option>
                                            </select>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <button
                                                v-on:click="removeObject"
                                                class="button squared expanded with-icon red">
                                                <i class="material-icons">delete</i>
                                                Delete Text
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <span
                                    v-on:click="selectFunction('Artwork')"
                                    class="icon icon-design  function-switch"
                                    v-if="activeMode === 'Design'"
                                    v-bind:class="{ active : selectedFunction === 'Artwork' }">
                                    <i
                                        class="material-icons xl"
                                        style="position:relative; top: 12px; left: -20px;">
                                        view_headline
                                    </i>
                                    Artwork
                                </span>
                            </div>
                            <div
                                class="grid-x grid-padding-x marg-bottom-xs"
                                v-if="activeMode === 'Design'">
                                <div class="cell small-12">
                                    <div class="pad--small">
                                        <span
                                            v-on:click="addNames(selectedProduct)"
                                            class="button squared"
                                            title="Click this button if you want to add names to the garments">
                                            ADD NAMES
                                            <i class="material-icons">add</i>
                                        </span>
                                        <span
                                            v-on:click="associateDesign(selectedProduct.id)"
                                            class="button squared"
                                            title="Click this button if you want to apply the current design to this garment">
                                            USE THIS DESIGN
                                            <i class="material-icons">&nbsp;</i>
                                        </span>
                                        <span
                                            v-on:click="addDesign"
                                            class="button squared"
                                            title="Click this button if you want to start a new design for this garment">
                                            ADD NEW DESIGN
                                            <i class="material-icons">&nbsp;</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="selectedFunction === 'Save'"
                                class="pad--small">
                                <div class="grid-x grid-padding-x">
                                    <div v-if="saving === false" class="cell small-12 medium-10">
                                        <label>Name your design for reference</label>
                                        <input
                                            type="text"
                                            v-model="designName" />
                                    </div>
                                    <div v-else class="cell small-12">
                                        <p class="saving-indicator">Saving your design</p>
                                    </div>
                                </div>
                                <div class="grid-x grid-padding-x">
                                    <div class="cell small-12 medium-6">
                                        <button
                                            v-on:click="saveDesign"
                                            class="button light-blue squared expanded with-icon">
                                            Save design
                                            <i class="material-icons">save</i>
                                        </button>
                                    </div>
                                    <div class="cell small-12 medium-6">
                                        <span
                                            v-on:click="nextStep"
                                            class="button squared expanded with-icon">
                                            Checkout
                                            <i class="material-icons">shopping_cart</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="selectedFunction === 'Artwork'"
                                class="pad-small">
                                <h5 class="text-blue pad-bottom">Artwork</h5>
                                <div
                                    v-if="chooseDecorationType === true">
                                    <div class="grid-x grid-padding-x">
                                        <div class="cell small-12">
                                            <img v-bind:src="currentImageUrl" alt="" />
                                        </div>
                                    </div>
                                    <div class="grid-x grid-padding-x pad-top--large">
                                        <div class="cell small-12 medium-6">
                                            <button
                                                v-on:click="addImageToCanvas('embroidery')"
                                                class="button squared with-icon expanded">
                                                Add as embroidery
                                                <i class="material-icons">gesture</i>
                                            </button>
                                        </div>
                                        <div class="cell small-12 medium-6">
                                            <button
                                                v-on:click="addImageToCanvas('print')"
                                                class="button squared with-icon expanded">
                                                Add as print
                                                <i class="material-icons">brush</i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="grid-x grid-padding-x pad-top">
                                        <div class="cell small-12">
                                            <p class="text-center">
                                                <span
                                                    v-on:click="chooseDecorationType = false"
                                                    class="link delete-box">
                                                    <i class="material-icons">delete</i>
                                                    Cancel
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p class="small">
                                        Click image to add it to your design.
                                    </p>
                                    <ul class="artwork-list">
                                        <li
                                            v-for="image in images"
                                            v-bind:key="image.id"
                                            class="artwork">
                                            <img
                                                draggable="false"
                                                class="image-link"
                                                v-on:click="addImage"
                                                v-if="image.converted === false"
                                                v-bind:data-name="image.name"
                                                data-converted="notConverted"
                                                v-bind:src="`https://runsmart-dropship.s3.eu-west-2.amazonaws.com/new_uploads/thumbnail_200/${image.name}`"
                                                alt="" />
                                            <img
                                                draggable="false"
                                                class="image-link"
                                                v-on:click="addImage"
                                                v-else
                                                v-bind:data-name="image.conversion"
                                                data-converted="converted"
                                                v-bind:src="`https://runsmart-dropship.s3.eu-west-2.amazonaws.com/new_uploads/conversions/${image.conversion}`"
                                                alt="" />
                                        </li>
                                    </ul>
                                    <div class="grid-x grid-padding-x pad-top">
                                        <div class="small-12 medium-6">
                                            <div class="pad-left">
                                                <button
                                                    v-on:click="removeObject"
                                                    class="button squared expanded with-icon red">
                                                    <i class="material-icons">delete</i>
                                                    Remove Artwork
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pad--small">
                                <div
                                    v-if="selectedFunction !== 'Save'"
                                    class="grid-x grid-padding-x">
                                    <div class="cell small-12 medium-6">
                                        <span
                                            v-on:click="selectFunction('Save')"
                                            class="button light-blue squared expanded with-icon"
                                            v-if="activeMode === 'Design'"
                                            v-bind:class="{ active : selectedFunction === 'Save' }">
                                            SAVE DESIGN
                                            <i class="material-icons">save</i>
                                        </span>
                                    </div>
                                    <div class="cell small-12 medium-6">
                                        <span
                                            v-on:click="previewAll = true"
                                            class="button squared expanded with-icon"
                                            v-if="activeMode === 'Design'"
                                            v-bind:class="{ active : selectedFunction === 'Save' }">
                                            PREVIEW ALL
                                            <i class="material-icons">&nbsp;</i>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="grid-x grid-padding-x">
                                    <div class="cell small-12 medium-6">
                                        <span
                                            v-on:click="previewAll = true"
                                            class="button squared expanded with-icon"
                                            v-if="activeMode === 'Design'"
                                            v-bind:class="{ active : selectedFunction === 'Save' }">
                                            PREVIEW ALL
                                            <i class="material-icons">&nbsp;</i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cell small-12 medium-6 medium-order-1">
                    <div>
                        <div class="bordered light shadowed">
                            <div
                                v-if="selectedFunction === 'Design'"
                                class="show-for-small-only bordered light shadowed marg-bottom">
                                <ul class="design-nav">
                                    <li
                                        v-on:click="selectSide('Front')"
                                        v-bind:class="{ active : selectedSide === 'Front' }">
                                        Front
                                    </li>
                                    <li
                                        v-on:click="selectSide('Back')"
                                        v-bind:class="{ active : selectedSide === 'Back' }">
                                        Back
                                    </li>
                                    <li
                                        v-on:click="selectSide('Left')"
                                        v-bind:class="{ active : selectedSide === 'Left' }">
                                        Left
                                    </li>
                                    <li
                                        v-on:click="selectSide('Right')"
                                        v-bind:class="{ active : selectedSide === 'Right' }">
                                        Right
                                    </li>
                                </ul>
                            </div>
                            <div v-if="selectedFunction === 'Design' || selectedFunction === 'Text' || selectedFunction === 'Upload' || selectedFunction === 'Save' || selectedFunction === 'Artwork'">
                                <h4 class="pad-left">
                                    Design - {{ selectedSide }}
                                    <span class="float-right inline-block pad-top--xs pad-right">
                                        <span
                                            v-on:click="nextStep"
                                            class="button squared with-icon">
                                            Checkout
                                            <i class="material-icons">shopping_cart</i>
                                        </span>
                                    </span>
                                </h4>
                                <div
                                    class="easel"
                                    v-bind:class="`type_${selectedCategory}_${selectedSide}`">
                                    <div
                                        class="easel-inner"
                                        v-bind:style="{ backgroundImage: 'url(' + selectedDesignGarmentColour + ')' }">
                                        <canvas id="c"></canvas>
                                    </div>
                                </div>
                                <div
                                    v-if="showSelectedProducts === false"
                                    class="grid-x grid-padding-x pad">
                                    <div class="cell small-12">
                                        <h5
                                            class="accordian-header"
                                            v-on:click="showSelectedProducts = true">
                                            Selected products
                                            <span class="float-right">
                                                <i class="material-icons">keyboard_arrow_down</i>
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                                <div
                                    v-if="showSelectedProducts === true"
                                    class="grid-x grid-padding-x pad">
                                    <div
                                        class="cell small-12"
                                        v-for="(category, index) in categories"
                                        v-bind:key="index">
                                        <h5
                                            class="accordian-header"
                                            v-on:click="accordianOpen(index, category.garments[0].category_id)">
                                            {{ category.garments[0].category }}
                                            <span
                                                class="float-right"
                                                v-if="accordian === index">
                                                <i class="material-icons">keyboard_arrow_up</i>
                                            </span>
                                            <span
                                                class="float-right"
                                                v-else>
                                                <i class="material-icons">keyboard_arrow_down</i>
                                            </span>
                                        </h5>
                                        <div
                                            class="accordian-body"
                                            v-if="accordian === index">
                                            <div
                                                v-for="(garment, gIndex) in category.garments"
                                                v-bind:key="gIndex">
                                                <div class="grid-x grid-padding-x">
                                                    <div class="cell small-12 medium-8">
                                                        <span
                                                            v-if="selectedProduct === garment"
                                                            class="text-green">
                                                            Currently Selected
                                                        </span>
                                                        <h6>
                                                            {{ garment.product_code }}<br />
                                                            {{ garment.name }}
                                                        </h6>
                                                        <p
                                                            class="marg-bottom--xs small link"
                                                            v-for="(colour, cIndex) in garment.colours"
                                                            v-bind:key="cIndex"
                                                            v-bind:style="`color:#${colour.hex}`"
                                                            v-on:click="chooseDesignBackground"
                                                            v-bind:data-category="index"
                                                            v-bind:data-product="colour.product_code"
                                                            v-bind:data-colour="colour.code"
                                                            v-bind:data-garment="garment.id">
                                                            <strong>
                                                                Select {{ colour.colour }}
                                                            </strong>
                                                            <br />
                                                            <span
                                                                v-for="(size, index) in colour.sizes"
                                                                v-bind:key="index"
                                                                class="small">
                                                                {{ size.size }} * {{ size.quantity }}
                                                                &nbsp;&nbsp;
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div class="small-12 medium-3">
                                                        <img
                                                            v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=200`"
                                                            alt="" />
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid-x grid-padding-x pad-top pad-bottom">
                                    <div
                                        v-if="existingDesigns.length > 0"
                                        class="cell small-12 medium-4">
                                        <p>You have {{ existingDesigns.length }} design in your library</p>
                                        <div
                                            v-for="(design, index) in existingDesigns"
                                            v-bind:key="index">
                                            <button
                                                v-on:click="loadDesign(index)"
                                                class="button ghost slender">
                                                Load design {{ (index + 1) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="selectedFunction === 'Products'">
                                <app-garments></app-garments>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="nameForm"
            class="modal__wrap">
            <div class="modal__inner">
                <span
                    v-on:click="closeNameForm"
                    class="modal__close">X</span>
                <p class="small pad-top--xs">
                    * If you would like to add names to your garments please use the text
                    tool to add<br /> "Name Here" where you would like the name. Then use
                    this form to add names.
                </p>
                <app-name-form v-bind:garment="currentGarment"></app-name-form>
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 medium-4 medium-offset-2">
                        <button
                            v-on:click="closeNameForm"
                            class="button expanded">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="guidancePopUp === true"
            class="guidance-popup-wrap">
            <div class="guidance-popup">
                <h4 class="text-center pop-head">
                    How do I customise this item?
                </h4>
                <h5 class="text-center pop-benefit">
                    3 Simple steps
                </h5>
                <div>
                    <div class="five-col-one text-center">
                        <img class="pop-icon" src="../../../static/icons/basket-icon.png" alt="" />
                    </div>
                    <div class="five-col-half text-center">
                        <span class="pop-arrow">&rarr;</span>
                    </div>
                    <div class="five-col-one text-center">
                        <img class="pop-icon" src="../../../static/icons/garment-icon.png" alt="" />
                    </div>
                    <div class="five-col-half text-center">
                        <span class="pop-arrow">&rarr;</span>
                    </div>
                    <div class="five-col-one text-center">
                        <img class="pop-icon" src="../../../static/icons/trolley-icon.png" alt="" />
                    </div>
                </div>
                <div class="clear">
                    <div class="five-col-one text-center">
                        <span class="pop-sub">Add to basket</span><br />
                        <span class="pop-guidance">Choose your garments</span>
                    </div>
                    <div class="five-col-half text-center">
                        &nbsp;
                    </div>
                    <div class="five-col-one text-center">
                        <span class="pop-sub">Customise</span><br />
                        <span class="pop-guidance">Upload your designs</span>
                    </div>
                    <div class="five-col-half text-center">
                        &nbsp;
                    </div>
                    <div class="five-col-one text-center">
                        <span class="pop-sub">Checkout</span><br />
                        <span class="pop-guidance">Payment and delivery options</span>
                    </div>
                </div>
                <p class="clear pad-top text-center">
                    <button class="button" v-on:click="guidancePopUp = false">
                        SHOP NOW
                    </button>
                </p>
            </div>
        </div>
        <div
            v-if="designAdvice === true"
            class="design-popup-wrap">
            <div class="design-popup">
                <span
                    class="close-popup"
                    v-on:click="designAdvice = false">
                    X
                </span>
                <h4 class="text-center pop-head">
                    How do I customise this item?
                </h4>
                <h5 class="text-center pop-benefit">
                    Drag &amp; Resize
                </h5>
                <p class="text-center">
                    <img class="pop-icon large" src="../../../static/icons/customise-icon.png" alt="" />
                </p>
                <p class="pop-guidance text-center">
                    Use the anchor points around your logo to your desired size and move into position.
                </p>
                <p class="pop-guidance text-center">
                    Once you’re happy with positioning you can check out the final preview before checkout. We’ll also email you with a Visual Proof within 24 hours inc the exact dimensions, the colours to be used and the position of your branding.
                </p>
            </div>
        </div>
        <app-preview-designs
            v-on:closePreviewAll="previewAll = false"
            v-on:checkoutFromPreview="nextStep"
            v-if="previewAll === true"></app-preview-designs>
    </div>
</template>

<script>
import uploader from '@/components/Uploader/Uploader';
import garments from '@/components/Garments/ModalGarments';
import fabric from 'fabric';
import nameForm from '@/components/Order/NameForm';
import previewAllDesigns from '@/components/Order/PreviewAll';
import axios from '../../axios';

export default {
    name: 'DesignGarment',
    metaInfo() {
        return {
            title: 'Design your clothing',
            titleTemplate: '%s-CustomisedClothing',
            meta: [
                { description: 'Make garments your own with customised clothing. Choose from our selection and make pieces that match your personality. Order now!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/order/design' },
            ],
        };
    },
    components: {
        appNameForm: nameForm,
        appUploader: uploader,
        appGarments: garments,
        appPreviewDesigns: previewAllDesigns,
    },
    data() {
        return {
            images: [],
            categories: [],
            started: false,
            canvas: '',
            textColor: '#000',
            textFont: 'Arial',
            textAlign: 'left',
            currentGarment: {},
            nameForm: false,
            currentDesignId: 0,
            currentDesignGroup: 0,
            currentImageUrl: '',
            chooseDecorationType: false,
            currentDecorationType: '',
            objectCount: 0,
            selectedCategory: 0,
            accordian: 999,
            saving: false,
            existingDesigns: [],
            selectedSide: 'Front',
            selectedFunction: 'Design',
            activeMode: 'Design',
            addingArtwork: false,
            designName: '',
            canvasWidth: 0,
            canvasHeight: 0,
            backgroundChosen: false,
            imageLoaded: false,
            guidancePopUp: false,
            showSelectedProducts: false,
            selectedProduct: {},
            designAdvice: false,
            previewAll: false,
            newDesignNeeded: false,
        };
    },
    computed: {
        imageIds() { return this.$store.getters.images; },
        basketId() { return this.$store.getters.basketId; },
        basketSubTotal() { return this.$store.getters.basketSubTotal; },
        selectedDesignGarmentColour() {
            let sdgc = false;
            if (this.categories[0]) {
                let side = '';
                if (this.selectedSide === 'Front') {
                    side = 'FRONT';
                } else if (this.selectedSide === 'Back') {
                    side = 'BACK';
                } else if (this.selectedSide === 'Left') {
                    side = 'LEFT';
                } else if (this.selectedSide === 'Right') {
                    side = 'RIGHT';
                }
                let productCode = '';
                let colourCode = '';
                if (this.backgroundChosen === false) {
                    productCode = this.categories[0].garments[0].colours[0].product_code;
                    colourCode = this.categories[0].garments[0].colours[0].code;
                } else {
                    productCode = this.backgroundChosen.productCode;
                    colourCode = this.backgroundChosen.colourCode;
                }
                sdgc = `https://runsmart-dropship.s3.eu-west-2.amazonaws.com/garments/pencarrie_images/${productCode}+${colourCode}+${side}.jpg`;
            }
            return sdgc;
        },
    },
    methods: {
        chooseDesignBackground(event) {
            const element = event.currentTarget;
            const product = element.getAttribute('data-product');
            const colour = element.getAttribute('data-colour');
            const garmentId = parseInt(element.getAttribute('data-garment'), 10);
            const catIndex = parseInt(element.getAttribute('data-category'), 10);
            const garmentsGroup = this.categories[catIndex].garments;
            const garment = garmentsGroup.filter(el => el.id === garmentId);
            this.selectedProduct = garment[0];
            this.backgroundChosen = {};
            this.backgroundChosen.productCode = product;
            this.backgroundChosen.colourCode = colour;
        },
        uploadHasFinished() {
            this.fetchImages();
            // this.selectedFunction = 'Design';
            this.selectFunction('Artwork');
        },
        selectMode(selectedMode) {
            this.activeMode = selectedMode;
            if (selectedMode === 'Products') {
                this.selectedFunction = 'Products';
            } else {
                this.selectedFunction = 'Design';
                this.designGarments();
            }
        },
        selectFunction(selectedFunction) {
            this.selectedFunction = selectedFunction;
            this.fetchImages();
            this.fetchGarments();
        },
        selectSide(side) {
            const postData = {};
            postData.basketId = this.basketId;
            postData.canvasString = JSON.stringify(this.canvas);
            postData.side = this.selectedSide;
            postData.newSide = side;
            postData.group = this.currentDesignGroup;
            axios.post(`/Designs/saveSide/${this.currentDesignId}.json`, postData)
                .then((response) => {
                    this.currentDesignId = response.data.newDesign.id;
                    this.currentDesignGroup = response.data.newDesign.design_group;
                    this.canvas.dispose();
                    const json = response.data.newDesign.canvas_string;
                    this.canvas = new fabric.fabric.Canvas('c');
                    // eslint-disable-next-line
                    this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });
                    this.canvas.loadFromJSON(
                        json,
                        this.canvas.renderAll.bind(this.canvas),
                    );
                });
            this.selectedSide = side;
        },
        loadDesign(index) {
            this.canvas.dispose();
            const design = this.existingDesigns[index];
            const json = design.canvas_string;
            this.canvas = new fabric.fabric.Canvas('c');
            this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });
            this.canvas.loadFromJSON(
                json,
                this.canvas.renderAll.bind(this.canvas),
            );
        },
        getDesigns() {
            axios.get(`/Designs/getDesigns/${this.basketId}.json`)
            .then((response) => {
                this.existingDesigns = response.data.designs;
            });
        },
        saveDesign() {
            this.saving = true;
            const postData = {};
            postData.basketId = this.basketId;
            postData.canvasString = JSON.stringify(this.canvas);
            postData.name = this.designName;
            axios.post(`/Designs/saveDesignBasket/${this.currentDesignId}.json`, postData)
            .then(() => {
                setTimeout(() => {
                    this.saving = false;
                }, 500);
            });
        },
        accordianOpen(index, categoryId) {
            this.selectedCategory = categoryId;
            if (this.accordian !== index) {
                this.accordian = index;
            } else {
                this.accordian = 999;
            }
        },
        addDesign() {
            this.canvas.dispose();
            this.designGarments();
            this.$scrollTo('#artBoard', 300, { offset: -250 });
        },
        addNames(garment) {
            this.currentGarment = garment;
            this.nameForm = true;
        },
        closeNameForm() {
            this.currentGarment = {};
            this.nameForm = false;
        },
        associateDesign(garmentId) {
            const canvasString = JSON.stringify(this.canvas);
            const postData = {};
            postData.canvasString = canvasString;
            axios.post(`/Designs/saveDesign/${this.currentDesignId}.json`, postData)
                .then((response) => {
                    const secondPostData = {};
                    secondPostData.garmentId = garmentId;
                    secondPostData.currentDesignId = response.data.design.id;
                    secondPostData.basketId = this.basketId;
                    axios.post('/Designs/associateDesign.json', secondPostData);
                });
        },
        nextStep() {
            const canvasString = JSON.stringify(this.canvas);
            const postData = {};
            postData.designId = this.currentDesignId;
            postData.canvasString = canvasString;
            postData.basketId = this.basketId;
            axios.post('/Designs/finaliseDesign.json', postData)
                .then(() => {
                    this.$router.push('/checkout/basket/');
                });
        },
        fetchImages() {
            const imageIds = this.imageIds;
            axios.post('/Files/getFiles.json', imageIds)
                .then((response) => {
                    const images = [];
                    for (let i = 0; i < response.data.images.length; i += 1) {
                        images.push(response.data.images[i]);
                    }
                    this.images = images;
                });
        },
        fetchGarments() {
            axios.get(`/Garments/getGarments.json?basket=${this.basketId}`)
                .then((response) => {
                    const categories = [];
                    for (let i = 0; i < response.data.categories.length; i += 1) {
                        categories.push(response.data.categories[i]);
                    }
                    this.categories = categories;
                    if (categories[0]) {
                        if (categories[0].garments[0]) {
                            this.selectedProduct = categories[0].garments[0];
                            if (response.data.design) {
                                const design = response.data.design;
                                this.currentDesignId = design.id;
                                const json = design.canvas_string;
                                this.canvas = new fabric.fabric.Canvas('c');
                                // eslint-disable-next-line
                                this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });
                                this.canvas.loadFromJSON(
                                    json,
                                    this.canvas.renderAll.bind(this.canvas),
                                );
                                this.started = true;
                            } else {
                                this.newDesignNeeded = true;
                            }
                        } else {
                            this.newDesignNeeded = true;
                        }
                    } else {
                        this.newDesignNeeded = true;
                    }
                });
        },
        designGarments() {
            setTimeout(() => {
                if (this.newDesignNeeded === true) {
                    axios.get(`/Designs/createDesign.json?basket=${this.basketId}`)
                    .then((response) => {
                        this.currentDesignId = response.data.designId;
                        this.canvas = new fabric.fabric.Canvas('c');
                        // eslint-disable-next-line
                        this.canvas.setDimensions({ width: this.canvasWidth, height: this.canvasHeight });
                        // this.canvas.isDrawingMode = true;
                        this.started = true;
                    });
                }
            }, 800);
        },
        addImage(event) {
            const element = event.currentTarget;
            const name = element.getAttribute('data-name');
            const converted = element.getAttribute('data-converted');
            if (converted === 'converted') {
                this.currentImageUrl = `https://runsmart-dropship.s3.eu-west-2.amazonaws.com/new_uploads/conversions/${name}`;
            } else {
                this.currentImageUrl = `https://runsmart-dropship.s3.eu-west-2.amazonaws.com/new_uploads/thumbnail_200/${name}`;
            }
            this.currentDecorationType = 'embroidery';
            this.chooseDecorationType = true;
        },
        removeObject() {
            const object = this.canvas.getActiveObject();
            // eslint-disable-next-line
            const id = object.__ob__.dep.id;
            const postData = {};
            postData.id = id;
            postData.designId = this.currentDesignId;
            axios.post('/Manifests/removeItem.json', postData)
            .then(() => {
                this.canvas.remove(object);
            });
        },
        addImageToCanvas(type) {
            const url = this.currentImageUrl;
            fabric.fabric.Image.fromURL(url, (oImg) => {
                this.canvas.add(oImg.scale(0.4).set({
                    left: 100,
                    top: 100,
                }));
            });
            setTimeout(() => {
                // eslint-disable-next-line
                const canvasObjects = this.canvas._objects;
                const position = (canvasObjects.length - 1);
                const last = canvasObjects[position];
                // eslint-disable-next-line
                const id = last.__ob__.dep.id;
                this.saveDecorationType(type, id);
                this.designAdvice = true;
            }, 10);
        },
        saveDecorationType(type, id) {
            this.currentDecorationType = type;
            this.chooseDecorationType = false;
            const postData = {};
            postData.designId = this.currentDesignId;
            postData.object = this.objectCount;
            postData.url = this.currentImageUrl;
            postData.type = this.currentDecorationType;
            postData.id = id;
            axios.post('/Manifests/addItem.json', postData)
                .then(() => {
                    this.objectCount += 1;
                });
        },
        addText(type) {
            const newID = (new Date()).getTime().toString().substr(5);
            const text = new fabric.fabric.IText('Click to edit.', {
                fontFamily: 'arial',
                left: 25,
                top: 245,
                myid: newID,
                objecttype: 'text',
            });
            this.canvas.add(text);
            // eslint-disable-next-line
            const id = text.__ob__.dep.id;
            this.saveDecorationText(type, id);
        },
        saveDecorationText(processType, id) {
            this.currentDecorationType = processType;
            this.chooseDecorationType = false;
            const postData = {};
            postData.designId = this.currentDesignId;
            postData.object = this.objectCount;
            postData.url = this.currentImageUrl;
            postData.type = this.currentDecorationType;
            postData.id = id;
            axios.post('/Manifests/addItem.json', postData)
                .then(() => {
                    this.objectCount += 1;
                });
        },
        updateTextColour() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                obj.setColor(this.textColor);
                this.canvas.renderAll();
            }
        },
        updateTextFont() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                obj.fontFamily = this.textFont;
                this.canvas.renderAll();
            }
        },
        updateTextAlign() {
            const obj = this.canvas.getActiveObject();
            if (obj) {
                obj.textAlign = this.textAlign;
                this.canvas.renderAll();
            }
        },
        getWidth() {
            const width = Math.max(
                document.body.scrollWidth,
                document.documentElement.scrollWidth,
                document.body.offsetWidth,
                document.documentElement.offsetWidth,
                document.documentElement.clientWidth,
            );
            if (width < 400) {
                this.canvasWidth = 370;
                this.canvasHeight = 425;
            } else if (width < 500) {
                this.canvasWidth = 468;
                this.canvasHeight = 541;
            } else if (width < 640) {
                this.canvasWidth = 288;
                this.canvasHeight = 333;
            } else if (width < 700) {
                this.canvasWidth = 317;
                this.canvasHeight = 367;
            } else if (width < 800) {
                this.canvasWidth = 367;
                this.canvasHeight = 425;
            } else if (width < 900) {
                this.canvasWidth = 418;
                this.canvasHeight = 483;
            } else if (width < 1000) {
                this.canvasWidth = 468;
                this.canvasHeight = 542;
            } else if (width < 1100) {
                this.canvasWidth = 518;
                this.canvasHeight = 600;
            } else if (width < 1200) {
                this.canvasWidth = 568;
                this.canvasHeight = 657;
            } else if (width < 1300) {
                this.canvasWidth = 618;
                this.canvasHeight = 714;
            } else if (width < 1400) {
                this.canvasWidth = 668;
                this.canvasHeight = 772;
            } else if (width < 1500) {
                this.canvasWidth = 718;
                this.canvasHeight = 830;
            } else if (width < 1600) {
                this.canvasWidth = 768;
                this.canvasHeight = 888;
            } else {
                this.canvasWidth = 818;
                this.canvasHeight = 945;
            }
        },
        updateLoadCategory() {
            setTimeout(() => {
                if (this.categories[0]) {
                    this.selectedCategory = this.categories[0].garments[0].category_id;
                } else {
                    this.selectedCategory = 1;
                }
            }, 600);
        },
        checkBasket() {
            if (this.basketSubTotal === 0) {
                this.guidancePopUp = true;
                this.activeMode = 'Products';
                this.selectedFunction = 'Products';
            }
        },
    },
    mounted() {
        this.getWidth();
        this.checkBasket();
        this.fetchImages();
        this.fetchGarments();
        this.getDesigns();
        this.updateLoadCategory();
        this.designGarments();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Order/Design.vue